import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { tokenAPI } from "../../utils/api";

const TokenManagement = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchTokens = async () => {
    setLoading(true);
    try {
      const res = await tokenAPI.getAll();
      setTokens(res.data || []);
    } catch (e) {
      console.error(e);
      setError("Failed to load tokens.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const handleGenerate = async () => {
    setLoading(true);
    try {
      await tokenAPI.create();
      await fetchTokens();
    } catch (e) {
      console.error(e);
      setError("Failed to generate token.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6">Student Registration Tokens</Typography>
      {error && (
        <Typography color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
      <Box sx={{ my: 2 }}>
        <Button variant="contained" onClick={handleGenerate} disabled={loading}>
          {loading ? "Generating..." : "Generate New Token"}
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Token</TableCell>
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tokens.map((t) => (
              <TableRow key={t.id}>
                <TableCell>{t.token}</TableCell>
                <TableCell>{new Date(t.createdAt).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {tokens.length === 0 && !loading && (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  No tokens found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TokenManagement;
